<template>
    <form @submit.prevent="submit()" @keydown="form.clearError($event.target.name)">
        <b-row>
            <b-col lg="6">
                <b-card header="Service Address"
                    header-bg-variant="info"
                    header-text-variant="white"
                    >
                    <b-form-group label="Address Line 1" label-for="address1">
                        <b-form-input
                                name="address1"
                                type="text"
                                v-model="form.service_address.address1"
                                :disabled=" isDisabled "
                        >
                        </b-form-input>
                        <input-help :form="form" field="service_address.address1" text=""></input-help>
                    </b-form-group>
                    <b-form-group label="Address Line 2" label-for="address2">
                        <b-form-input
                                name="address2"
                                type="text"
                                v-model="form.service_address.address2"
                                :disabled=" isDisabled "
                        >
                        </b-form-input>
                        <input-help :form="form" field="service_address.address2" text=""></input-help>
                    </b-form-group>
                    <b-form-group label="City" label-for="city">
                        <b-form-input
                                name="city"
                                type="text"
                                v-model="form.service_address.city"
                                :disabled=" isDisabled "
                        >
                        </b-form-input>
                        <input-help :form="form" field="service_address.city" text=""></input-help>
                    </b-form-group>
                    <b-form-group label="Country" label-for="country">
                        <b-form-select name="country" :options="countries.getOptions()" v-model="form.service_address.country" :disabled=" isDisabled "/>
                        <input-help :form="form" field="service_address.country" text=""></input-help>
                    </b-form-group>
                    <b-form-group label="State" label-for="state" v-if="form.service_address.country === 'US'">
                        <b-form-select name="state" :options="states.getOptions()" v-model="form.service_address.state" :disabled=" isDisabled "/>
                        <input-help :form="form" field="service_address.state" text=""></input-help>
                    </b-form-group>
                    <b-form-group label="State" label-for="state" v-else>
                        <b-form-input
                                name="state"
                                type="text"
                                v-model="form.service_address.state"
                                :disabled=" isDisabled "
                        >
                        </b-form-input>
                        <input-help :form="form" field="service_address.state" text=""></input-help>
                    </b-form-group>
                    <b-form-group label="Zip Code" label-for="zip">
                        <b-form-input
                                name="zip"
                                type="text"
                                v-model="form.service_address.zip"
                                :disabled=" isDisabled "
                        >
                        </b-form-input>
                        <input-help :form="form" field="service_address.zip" text=""></input-help>
                    </b-form-group>
                </b-card>
            </b-col>
            <b-col lg="6">
                <b-card header="Mailing Address"
                    header-bg-variant="info"
                    header-text-variant="white"
                    >
                    <b-form-group label="Address Line 1" label-for="address1">
                        <b-form-input
                                name="address1"
                                type="text"
                                v-model="form.mailing_address.address1"
                                :disabled="isClient || isDisabled"
                        >
                        </b-form-input>
                        <input-help :form="form" field="mailing_address.address1" text=""></input-help>
                    </b-form-group>
                    <b-form-group label="Address Line 2" label-for="address2">
                        <b-form-input
                                name="address2"
                                type="text"
                                v-model="form.mailing_address.address2"
                                :disabled="isClient || isDisabled"
                        >
                        </b-form-input>
                        <input-help :form="form" field="mailing_address.address2" text=""></input-help>
                    </b-form-group>
                    <b-form-group label="City" label-for="city">
                        <b-form-input
                                name="city"
                                type="text"
                                v-model="form.mailing_address.city"
                                :disabled="isClient || isDisabled"
                        >
                        </b-form-input>
                        <input-help :form="form" field="mailing_address.city" text=""></input-help>
                    </b-form-group>
                    <b-form-group label="Country" label-for="country">
                        <b-form-select name="country" :options="countries.getOptions()" v-model="form.mailing_address.country" :disabled="isClient || isDisabled" />
                        <input-help :form="form" field="mailing_address.country" text=""></input-help>
                    </b-form-group>
                    <b-form-group label="State" label-for="state" v-if="form.mailing_address.country === 'US'">
                        <b-form-select name="state" :options="states.getOptions()" v-model="form.mailing_address.state" :disabled="isClient || isDisabled" />
                        <input-help :form="form" field="mailing_address.state" text=""></input-help>
                    </b-form-group>
                    <b-form-group label="State" label-for="state" v-else>
                        <b-form-input
                                name="state"
                                type="text"
                                v-model="form.mailing_address.state"
                                :disabled="isClient || isDisabled"
                        >
                        </b-form-input>
                        <input-help :form="form" field="mailing_address.state" text=""></input-help>
                    </b-form-group>
                    <b-form-group label="Zip Code" label-for="zip">
                        <b-form-input
                                name="zip"
                                type="text"
                                v-model="form.mailing_address.zip"
                                :disabled="isClient || isDisabled"
                        >
                        </b-form-input>
                        <input-help :form="form" field="mailing_address.zip" text=""></input-help>
                    </b-form-group>

                    <b-row v-if="isClient">
                        <b-col lg="12" class="text-center">
                            <h3>Please call {{ supportNumber }} if you would like to edit your information.</h3>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-row class="mb-4" v-show="!readonly">
            <b-col lg="12">
                <b-button variant="success" size="lg" type="submit" v-if="create">Save and Continue</b-button>
                <b-button variant="success" size="lg" type="submit" v-else-if=" !isCarrierManager ">Save Profile</b-button>
            </b-col>
        </b-row>
    </form>
</template>

<script>
    import States from '../classes/States';
    import UsesRole from "../mixins/UsesRole";
    export default {
        props: {
            'readonly': {
              type: Boolean,
              default: false,
            },
            'client': {},
            'create': Boolean,
            'supportNumber': String,
        },
        mixins: [UsesRole],

        data() {
            return {
                url: `${this.claimantUrlPrefix}/${this.client.id}/address`,
                countries: new Countries(),
                states: new States(),
                form: new Form({
                    service_address: { country: 'US' },
                    mailing_address: { country: 'US' },
                }),
            }
        },

        methods: {
            submit() {
                this.url = `${this.claimantUrlPrefix}/${this.client.id}/address`;

                this.form.put(this.url)
                    .then( response => {
                        if (this.create) {
                            this.$emit('continue');
                        }
                    });
            },

            loadAddresses() {
                let service_address = this.client.evv_address;
                if (service_address) {
                    this.form.service_address = service_address;
                }
                let mailing_address = this.client.mailing_address;
                if (mailing_address) {
                    this.form.mailing_address = mailing_address;
                }
            },
        },

        mounted() {
            this.loadAddresses();
        },

        watch: {
            'form.service_address.country': function() {
                this.form.service_address.state = "";
            },
            'form.mailing_address.country': function() {
                this.form.mailing_address.state = "";
            },
        },

        computed: {
          isDisabled() {
            return (!this.create && this.isCarrierManager) || this.readonly;
          }
        }
    }
</script>